import { useEffect, useState } from "react";

type NavigatorWithMS = Navigator & {
  msMaxTouchPoints?: number;
};

export function useDeviceType() {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    const nav = navigator as NavigatorWithMS;

    const hasTouch =
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      (nav.msMaxTouchPoints ?? 0) > 0;

    setIsTouch(hasTouch);
    document.documentElement.setAttribute("is_touch_device", String(hasTouch));
  }, []);

  return isTouch;
}
